<template>
  <Modal v-model="visible" :closeOnMask="true" :hasCloseIcon="true" class="home-modal-ad">
    <div class="home-modal-ad-content" @click="openLink">
      <transition name="fade" mode="out-in">
        <img :src="ad.imageUrl" class="home-modal-ad-image" alt="广告" :key="currentIndex" />
      </transition>
      <div v-if="ad.linkUrl" class="home-modal-ad-tip">
        <span>点击查看详情</span>
        <i class="fa fa-external-link"></i>
      </div>
      <div v-if="ads.length > 1" class="home-modal-ad-indicator">
        <span
            v-for="(item, index) in ads"
            :key="index"
            :class="['home-indicator-dot', { active: index === currentIndex }]"
            @click.stop="currentIndex = index"
        ></span>
      </div>
    </div>
    <template #footer>
      <div class="home-modal-ad-footer">
        <Button @click="closeToday">今日不再显示</Button>
        <Button color="primary" @click="visible = false">关闭</Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import api from '@/api'
import manba from 'manba'

const visible = ref(false)
const ads = ref([])
const currentIndex = ref(0)
let timer = null

const STORAGE_KEY = 'home_ad_dismiss_'

const ad = computed(() => ads.value[currentIndex.value] || {})

const closeToday = () => {
  const today = manba().format('YYYY-MM-DD')
  ads.value.forEach(item => {
    localStorage.setItem(STORAGE_KEY + item.id, today)
  })
  visible.value = false
}

const openLink = () => {
  if (ad.value.linkUrl) {
    window.open(ad.value.linkUrl, '_blank')
    visible.value = false
  }
}

const startRotation = () => {
  if (ads.value.length > 1) {
    timer = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % ads.value.length
    }, 5000)
  }
}

onMounted(() => {
  api.advertisement.getByPosition('home_modal').then(({ data }) => {
    if (data && data.length > 0) {
      ads.value = data
      const today = manba().format('YYYY-MM-DD')
      const allDismissed = data.every(item => localStorage.getItem(STORAGE_KEY + item.id) === today)
      if (!allDismissed) {
        visible.value = true
        startRotation()
      }
    }
  })
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style scoped>
.home-modal-ad-content {
  padding: 0;
  position: relative;
  cursor: pointer;
}
.home-modal-ad-content:hover .home-modal-ad-tip {
  opacity: 1;
}
.home-modal-ad-image {
  width: 100%;
  display: block;
  border-radius: 8px;
}
.home-modal-ad-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  color: #fff;
  font-size: 13px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.home-modal-ad-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.home-modal-ad-indicator {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 2;
}
.home-indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}
.home-indicator-dot.active {
  background: #fff;
  transform: scale(1.2);
}
.home-indicator-dot:hover {
  background: rgba(255, 255, 255, 0.8);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>